// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3GJyg","author":"Table_author__wPUc8","authorImage":"Table_authorImage__134qY","unreadRow":"Table_unreadRow__30DJA"};